function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4691 15.8036C21.3794 14.1342 24.4016 13.8003 27.1999 14.9133C29.4386 15.8036 31.4534 17.3617 33.0205 19.2537C33.0205 13.5777 33.1324 7.79051 33.1324 2.11457C33.1324 0.890344 32.2369 0 31.0057 0H4.02962C2.91028 0 2.01481 0.779051 1.90287 1.89198C0.783537 10.7954 0.223868 19.8101 0 28.8249C0 30.0491 0.89547 30.9394 2.12674 30.9394H16.3423C16.0065 30.4943 15.5588 29.9378 15.3349 29.3813C12.3127 24.2619 13.6559 18.5859 18.4691 15.8036Z",
  fill: "#D24826"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.2287 14.9133C49.027 13.8003 52.1612 14.1342 54.9595 15.8036C59.7727 18.5859 61.1159 24.2619 58.0936 29.3813C57.7578 29.9378 57.422 30.4943 57.0862 30.9394H70.7422C71.9734 30.9394 72.8689 29.9378 72.8689 28.8249C72.645 19.8101 72.0854 10.9067 70.966 1.89198C70.8541 0.779051 69.9586 0 68.8393 0H41.7513C40.52 0 39.6246 1.00164 39.6246 2.11457C39.7365 8.01309 39.7365 14.0229 39.7365 19.9214C41.5274 17.8069 43.6542 15.8036 46.2287 14.9133Z",
  fill: "#61AFB8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6699 54.5335L25.9686 55.3126C24.6254 46.8543 26.5283 40.9558 29.1028 37.0605H2.12674C0.89547 37.0605 0 38.0622 0 39.1751C0.223868 48.1898 0.783537 57.0933 1.90287 66.108C2.01481 67.2209 2.91028 68 4.02962 68H31.1176C32.3489 68 33.2443 66.9984 33.2443 65.8854C33.1324 57.2046 33.1324 48.5237 33.0205 39.8429C31.1176 42.8478 29.5505 47.6334 30.6699 54.5335Z",
  fill: "#D24826"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7422 37.0605H42.6468C45.2213 40.6219 49.3628 44.6285 54.2879 45.1849L53.7282 49.8592C47.6838 49.0802 42.9826 44.9623 39.8484 41.0671C39.8484 49.3028 39.7365 57.5384 39.7365 65.7741C39.7365 66.9983 40.632 67.8887 41.8633 67.8887H68.9512C70.0706 67.8887 70.966 67.1096 71.078 65.9967C72.1973 57.0933 72.757 48.0785 72.9809 39.0638C72.8689 37.9509 71.8615 37.0605 70.7422 37.0605Z",
  fill: "#61AFB8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5209 19.3649C24.9612 19.1424 24.4016 19.0311 23.8419 19.0311C22.8345 19.0311 21.939 19.3649 20.8197 19.9214C17.7975 21.7021 18.1333 24.8183 19.4765 27.0442C20.4839 28.7136 22.0509 30.1604 24.0658 30.9394H30.8937C32.125 30.9394 33.0205 29.9378 33.0205 28.8248C33.0205 28.6023 33.0205 28.2684 33.0205 28.0458C31.4534 24.707 28.767 20.4779 25.5209 19.3649Z",
  fill: "#D24826"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9521 27.0442C55.1834 24.8183 55.6311 21.7021 52.6089 19.9214C50.9299 18.9198 49.4748 18.8085 47.9077 19.365C44.3258 20.7005 41.4155 25.7087 39.8484 29.1587C39.9604 30.1604 40.8559 30.9394 41.9752 30.9394H49.3628C51.3776 30.1604 52.9447 28.7136 53.9521 27.0442Z",
  fill: "#61AFB8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7265 10.1276C83.7265 8.01306 84.2862 6.34366 85.2936 5.23073C86.301 4.1178 87.8681 3.56134 89.8829 3.56134C91.8977 3.56134 93.4647 4.1178 94.4721 5.23073C95.4796 6.34366 96.0392 8.01306 96.0392 10.1276V10.9067H92.1215V9.79375C92.1215 8.01306 91.4499 7.23401 89.9948 7.23401C88.6516 7.23401 87.868 8.12435 87.868 9.79375C87.868 10.5728 87.98 11.2406 88.3158 11.9083C88.6516 12.5761 88.9874 13.1325 89.5471 13.689C89.9948 14.2455 90.5545 14.6906 91.1141 15.2471C91.6738 15.8036 92.2335 16.2487 92.7931 16.8052C93.3528 17.3617 93.9125 17.9181 94.3602 18.5859C94.808 19.2537 95.2557 20.0327 95.5915 20.8118C95.9273 21.7021 96.0392 22.5924 96.0392 23.7054C96.0392 25.8199 95.4796 27.4893 94.4721 28.6023C93.3528 29.7152 91.8977 30.2717 89.8829 30.2717C87.8681 30.2717 86.301 29.7152 85.2936 28.6023C84.1742 27.4893 83.7265 25.8199 83.7265 23.7054V22.1473H87.6442V24.0392C87.6442 25.7086 88.3158 26.599 89.7709 26.599C91.2261 26.599 91.8977 25.7086 91.8977 24.0392C91.8977 23.0376 91.6738 22.1473 91.1141 21.2569C90.5545 20.3666 89.8829 19.5875 89.0993 18.9198C88.3158 18.252 87.5322 17.473 86.6368 16.6939C85.8532 15.9149 85.1816 15.0245 84.622 13.8003C83.9504 12.7987 83.7265 11.4631 83.7265 10.1276Z",
  fill: "#61AFB8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M102.643 7.5679V14.9132H108.352V18.6972H102.643V26.3764H109.919V30.0491H98.5018V3.78394H109.919V7.5679H102.643Z",
  fill: "#61AFB8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M112.493 30.0491V3.78394H116.635V26.2651H123.575V30.0491H112.493Z",
  fill: "#61AFB8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M125.366 30.0491V3.78394H129.507V26.2651H136.447V30.0491H125.366Z",
  fill: "#61AFB8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M142.492 7.5679V14.9132H148.2V18.6972H142.492V26.3764H149.767V30.0491H138.35V3.78394H149.767V7.5679H142.492Z",
  fill: "#61AFB8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M165.326 30.0491H161.073C160.849 29.27 160.737 28.2684 160.737 26.8216V22.7037C160.737 21.4795 160.513 20.7005 160.065 20.144C159.618 19.5875 158.946 19.365 157.939 19.365H156.483V30.0491H152.342V3.78394H158.61C160.737 3.78394 162.304 4.22911 163.311 5.23074C164.319 6.23238 164.767 7.79048 164.767 9.79376V11.9083C164.767 14.5794 163.871 16.36 162.08 17.2504C163.983 18.0294 164.879 19.9214 164.879 22.815V26.8216C164.879 28.2684 164.99 29.3813 165.326 30.0491ZM158.498 7.5679H156.483V15.581H158.162C158.946 15.581 159.618 15.3584 160.065 14.9132C160.513 14.4681 160.737 13.8003 160.737 12.7987V10.2389C160.625 8.45824 159.953 7.5679 158.498 7.5679Z",
  fill: "#61AFB8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M167.453 18.8085V15.0245H175.064V18.8085H167.453Z",
  fill: "#61AFB8"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M177.527 23.8167V10.1277C177.527 8.01309 178.087 6.45498 179.206 5.23076C180.325 4.11783 181.892 3.45007 183.907 3.45007C185.922 3.45007 187.489 4.00654 188.608 5.23076C189.728 6.34369 190.287 8.01309 190.287 10.1277V23.8167C190.287 25.9313 189.728 27.4894 188.608 28.7136C187.489 29.8265 185.922 30.4943 183.907 30.4943C181.892 30.4943 180.325 29.9378 179.206 28.7136C178.087 27.4894 177.527 25.82 177.527 23.8167ZM181.669 9.90507V24.0393C181.669 25.82 182.34 26.599 183.795 26.599C185.25 26.599 185.922 25.7087 185.922 24.0393V9.90507C185.922 8.12438 185.25 7.34533 183.795 7.34533C182.34 7.34533 181.669 8.12438 181.669 9.90507Z",
  fill: "#61AFB8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M201.929 30.0491L196.668 11.018V30.0491H192.862V3.78394H198.123L202.376 19.4762V3.78394H206.07V30.0491H201.929Z",
  fill: "#61AFB8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M209.204 30.0491V3.78394H213.346V26.2651H220.286V30.0491H209.204Z",
  fill: "#61AFB8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M222.077 30.0491V3.78394H226.218V30.0491H222.077Z",
  fill: "#61AFB8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M238.307 30.0491L233.046 11.018V30.0491H229.24V3.78394H234.501L238.755 19.4762V3.78394H242.449V30.0491H238.307Z",
  fill: "#61AFB8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M249.836 7.5679V14.9132H255.545V18.6972H249.836V26.3764H257.112V30.0491H245.695V3.78394H257.112V7.5679H249.836Z",
  fill: "#61AFB8"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7265 44.8511C83.7265 42.7365 84.2862 41.0671 85.2936 39.9542C86.301 38.8413 87.868 38.2848 89.8829 38.2848C91.8977 38.2848 93.4647 38.8413 94.4721 39.9542C95.4795 41.0671 96.0392 42.7365 96.0392 44.8511V45.6301H92.1215V44.5172C92.1215 42.8478 91.4499 41.9575 89.9948 41.9575C88.6516 41.9575 87.868 42.8478 87.868 44.5172C87.868 45.2962 87.98 45.964 88.3158 46.6318C88.6516 47.2995 88.9874 47.856 89.4351 48.4124C89.8829 48.9689 90.4425 49.4141 91.0022 49.9705C91.5619 50.527 92.1215 50.9722 92.6812 51.5286C93.2409 52.0851 93.8005 52.6416 94.2483 53.3093C94.696 53.9771 95.1437 54.7561 95.3676 55.5352C95.7034 56.4255 95.8153 57.3159 95.8153 58.4288C95.8153 60.5434 95.2557 62.2128 94.2483 63.3257C93.2409 64.4386 91.6738 64.9951 89.659 64.9951C87.6442 64.9951 86.0771 64.4386 85.0697 63.3257C84.0623 62.2128 83.5026 60.5434 83.5026 58.4288V56.8707H87.4203V58.7627C87.4203 60.4321 88.0919 61.3224 89.5471 61.3224C91.0022 61.3224 91.6738 60.4321 91.6738 58.7627C91.6738 57.7611 91.4499 56.8707 90.8903 55.9804C90.3306 55.09 89.659 54.311 88.8755 53.6432C88.0919 52.9755 87.3084 52.1964 86.5248 51.4174C85.7413 50.6383 85.0697 49.748 84.51 48.5237C83.9504 47.4108 83.7265 46.1866 83.7265 44.8511Z",
  fill: "#374259"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M98.9495 38.5074H103.091V58.7627C103.091 60.4321 103.763 61.3224 105.218 61.3224C106.673 61.3224 107.344 60.4321 107.344 58.7627V38.5074H111.262V58.5401C111.262 60.6547 110.703 62.3241 109.695 63.437C108.688 64.5499 107.121 65.1064 105.106 65.1064C103.091 65.1064 101.524 64.5499 100.517 63.437C99.5091 62.3241 98.9495 60.6547 98.9495 58.5401V38.5074Z",
  fill: "#374259"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M121.112 38.5074C125.254 38.5074 127.269 40.622 127.269 44.9624V48.4125C127.269 52.7529 125.254 54.8675 121.112 54.8675H119.098V64.7725H114.956V38.5074H121.112ZM121.112 42.2913H119.098V51.1948H121.112C121.784 51.1948 122.344 50.9722 122.679 50.6383C123.015 50.3044 123.239 49.6367 123.239 48.7463V44.8511C123.239 43.9607 123.015 43.293 122.679 42.9591C122.232 42.5139 121.784 42.2913 121.112 42.2913Z",
  fill: "#374259"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M134.209 42.2913V49.6367H139.917V53.4206H134.209V61.0999H141.372V64.8838H130.067V38.5074H141.372V42.2913H134.209Z",
  fill: "#374259"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M157.603 64.7725H153.349C153.125 63.9935 153.013 62.9918 153.013 61.545V57.4272C153.013 56.203 152.79 55.4239 152.342 54.8675C151.894 54.311 151.223 54.0884 150.215 54.0884H148.872V64.7725H144.73V38.5074H150.999C153.125 38.5074 154.693 38.9526 155.7 39.9542C156.707 40.9558 157.155 42.5139 157.155 44.5172V46.6318C157.155 49.3028 156.26 51.0835 154.469 51.9738C156.26 52.7529 157.267 54.6449 157.267 57.5385V61.545C157.155 62.9918 157.379 64.1048 157.603 64.7725ZM150.887 42.2913H148.872V50.3044H150.439C151.223 50.3044 151.894 50.0819 152.342 49.6367C152.79 49.1915 153.013 48.5238 153.013 47.5221V44.9624C153.013 43.1817 152.342 42.2913 150.887 42.2913Z",
  fill: "#374259"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M166.446 38.5074L169.468 57.0933L172.266 38.5074H178.087V64.7725H174.169V45.964L171.259 64.7725H167.341L164.207 46.1866V64.7725H160.625V38.5074H166.446Z",
  fill: "#374259"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M191.183 38.5074L195.436 64.7725H191.295L190.623 59.9869H185.586L184.915 64.7725H181.109L185.362 38.5074H191.183ZM187.937 43.1817L185.922 56.4256H189.952L187.937 43.1817Z",
  fill: "#374259"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M211.107 64.7725H206.854C206.63 63.9935 206.518 62.9918 206.518 61.545V57.4272C206.518 56.203 206.294 55.4239 205.846 54.8675C205.399 54.311 204.727 54.0884 203.72 54.0884H202.264V64.7725H198.123V38.5074H204.391C206.518 38.5074 208.085 38.9526 209.092 39.9542C210.1 40.9558 210.547 42.5139 210.547 44.5172V46.6318C210.547 49.3028 209.652 51.0835 207.861 51.9738C209.652 52.7529 210.659 54.6449 210.659 57.5385V61.545C210.547 62.9918 210.771 64.1048 211.107 64.7725ZM204.279 42.2913H202.264V50.3044H203.831C204.615 50.3044 205.287 50.0819 205.734 49.6367C206.182 49.1915 206.406 48.5238 206.406 47.5221V44.9624C206.406 43.1817 205.734 42.2913 204.279 42.2913Z",
  fill: "#374259"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M223.644 64.7725L219.614 54.311L218.271 56.7594V64.7725H214.129V38.5074H218.271V49.9706L223.756 38.5074H227.897L222.077 50.1931L227.897 64.7725H223.644Z",
  fill: "#374259"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M234.725 42.2913V49.6367H240.434V53.4206H234.725V61.0999H241.889V64.8838H230.584V38.5074H241.889V42.2913H234.725Z",
  fill: "#374259"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M244.128 42.2913V38.5074H257V42.2913H252.635V64.7725H248.493V42.2913H244.128Z",
  fill: "#374259"
});

var SvgMarket = function SvgMarket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 68,
    viewBox: "0 0 258 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/market.6e47138f.svg";
export { ForwardRef as ReactComponent };